import { useLocalization } from '@/Hooks';
import { ModalDialog } from '@/Components/ModalDialog/ModalDialog';
import React from 'react';

type Props = {
  onClose: () => void;
};

export const TemplateNotExists = ({ onClose }: Props) => {
  const {
    modalWindows: {
      emailSendModal: { TemplateNotExistsModal },
    },
  } = useLocalization();

  return <ModalDialog title={TemplateNotExistsModal.Title} text={TemplateNotExistsModal.Text} onOk={onClose} />;
};
